import Decision from "./Decision";
import Tag from "./Tag";
import States from "./States";

export default class Story {
    id:number = 1;
    text:string = "Enter story text here";
    textDecoded:string = "NA";
    currentDecisionId:number = 1;
    canDelete:boolean = true;
    decisions:Array<Decision> = [new Decision()];
    multiselect:boolean = true;
    onceOnly:boolean = false;
    tags:Array<Tag> = [];
    locked:boolean = false;

    public static getContinueStory(page:number, chapter:number):Story {
        let continueStory:Story = {
          id: -1,
          text: "<p><span class=\"ql-size-large\">Welcome back {name}</span></p><p>Would you like to continue where you left off?</p>",
          textDecoded: "NA",
          currentDecisionId: 1,
          canDelete: false,
          decisions: [
            {
                id: 1,
                decision: "Continue",
                outcome: "None",
                impact: "Tiny",
                shouldJump: true,
                jumpPage: page.toString(),
                jumpChapter: chapter.toString(),
                move: "Continue",
            },
            {
                id: 2,
                decision: "Replay from start",
                outcome: "None",
                impact: "Tiny",
                shouldJump: true,
                jumpPage: States.restart,
                jumpChapter: "0",
                move: "Stay",
            }
          ],
          multiselect: true,
          onceOnly: false,
          tags: [],
          locked: true,
        }
        return continueStory;
    }
}



// WEBPACK FOOTER //
// ./src/objects/Story.ts